export type ScheduleLike = {
  startDate?: string | null;
  endDate?: string | null;
};

/** Проверяет, активен ли элемент по startDate/endDate. Пустые даты = без ограничений. */
export const isScheduleActive = (
  item: ScheduleLike,
  now: Date | string | number = Date.now()
): boolean => {
  const nowMs = now instanceof Date ? now.getTime() : new Date(now).getTime();

  if (item.startDate) {
    const startMs = new Date(item.startDate).getTime();
    if (!Number.isNaN(startMs) && nowMs < startMs) return false;
  }

  if (item.endDate) {
    const endMs = new Date(item.endDate).getTime();
    if (!Number.isNaN(endMs) && nowMs > endMs) return false;
  }

  return true;
};

export const filterBySchedule = <T extends ScheduleLike>(
  items: T[],
  now?: Date | string | number
): T[] => items.filter((item) => isScheduleActive(item, now));
